import { Redirect } from 'models/redirect';
import {Agent, request} from './base';
import { ContentOverride } from 'models/content-override';

export class ContentOverridesAgent extends Agent<ContentOverride> {
    constructor() {
        super(ContentOverride, '/content-override');
    }

    sync = async () => {
        await request.post('/content-override/sync', {});
    };
}
